/* istanbul ignore file */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import StaticContainer from 'react-static-container';
import { connect } from 'react-redux';
import ModalBox from 'yoda-core-components/lib/components/ModalBox/ModalBox';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import IconClose from 'yoda-core-components/lib/assets/svg/IconClose.svg';
import ScriptLoader from 'yoda-core-components/lib/helpers/ScriptLoader/ScriptLoader';
import Loading from 'yoda-site-components/lib/components/Loading/Loading';
import LoadingAction from 'yoda-site-components/lib/actions/LoadingAction';

import classNames from 'classnames/bind';
import * as styles from './ImageZoom.css';

const cx = classNames.bind(styles);
let zoomViewer;
let setUpZoomCallback;

const getAssetData = (productImages) => {
    let assetData = '';
    const strPattern = /JCPenney\/[^?]*/g;
    productImages.forEach((productImage) => {
        const Url = productImage.url;
        const assetUrl = Url.match(strPattern);
        assetData += assetUrl[0];
        assetData += ',';
    });
    return assetData;
};

const setupZoomViewer = (() => {
    let initialized = false;

    return (productImages) => {
        const assetData = getAssetData(productImages);
        /* global  s7viewers:true */
        zoomViewer = new s7viewers.ZoomViewer({
            containerId: 'fakeZoomViewer',
            params: {
                asset: assetData,
                serverurl: 'https://jcpenney.scene7.com/is/image/',
                transition: '0.3,1',
                frametransition: 'slide, 0.3',
                pagemode: '1',
                buttomsnapmode: 'snapin',
                enableHD: 'always',
            },
        });

        // initalize zoomViewer and dispose it off to
        // speed up the initialization
        if (!initialized && !setUpZoomCallback) {
            zoomViewer.init();
            zoomViewer.dispose();
        }

        initialized = true;
        if (typeof setUpZoomCallback === 'function') {
            setUpZoomCallback();
        }
    };
})();

/* istanbul ignore next */
export const zoomViewerLoad = (() => {
    let loading = false;
    return (productImages, callback) => {
        setUpZoomCallback = callback;
        try {
            if (!window.s7viewers && !loading) {
                loading = true;
                const ZoomViewerScript = {
                    src: 'https://jcpenney.scene7.com/s7viewers/html5/js/ZoomViewer.js',
                    async: true,
                    defer: false,
                    onSuccess: () => {
                        loading = false;
                        setupZoomViewer(productImages);
                    },
                };
                ScriptLoader.load(ZoomViewerScript);
            }
        } catch (e) {
            console.error('Zoom viewer still not loaded', e);
        }
    };
})();

class ImageZoom extends Component {
    static defaultProps = {
        dataAutomationId: '',
        productImages: [],
        actions: {},
        closeCallback: null,
        selectedIndex: 0,
        isNative: false,
    };

    static propTypes = {
        dataAutomationId: PropTypes.string,
        productImages: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        closeCallback: PropTypes.func,
        selectedIndex: PropTypes.number,
        isNative: PropTypes.bool,
    };

    constructor() {
        super();
        this.state = {
            modelOpen: true,
        };
        this.closeModal = this.closeModal.bind(this);
        this.onZoomViewerLoad = this.onZoomViewerLoad.bind(this);
    }

    componentDidMount() {
        if (!s7viewers) {
            // Add loader only when zoom viewer is still downloading
            this.props.actions.showLoader();
            zoomViewerLoad(this.props.productImages, this.onZoomViewerLoad);
        } else {
            this.onZoomViewerLoad();
        }
    }

    componentWillUnmount() {
        // dispose off any existing zoomviewers.
        /* istanbul ignore else */
        if (zoomViewer && zoomViewer.dispose) {
            zoomViewer.dispose();
        }

        document.body.style.overflow = 'auto';
    }

    onZoomViewerLoad() {
        const { actions, productImages, selectedIndex } = this.props;
        setUpZoomCallback = null;
        setupZoomViewer(productImages);
        zoomViewer.setContainerId('s7viewer');
        // fix for invalid size inside query string
        zoomViewer.setParam('size', 0);
        zoomViewer.setParam('initialFrame', selectedIndex);

        /* istanbul ignore next */
        zoomViewer.setHandlers({
            initComplete() {
                actions.removeLoader();
                // document.querySelector('#s7viewer_fullScreenButton').click();
            },
        });
        zoomViewer.init();
    }

    closeModal() {
        this.setState({
            modelOpen: false,
        });

        // dispose off any existing zoomviewers.
        if (zoomViewer && zoomViewer.dispose) {
            zoomViewer.dispose();
        }

        this.props.closeCallback && this.props.closeCallback();
    }

    render() {
        return (
            <ModalBox
                showModal={this.state.modelOpen}
                onClose={this.closeModal}
                defaultCloseBtn={false}
                modalTheme={cx('imageModal')}
                modalBlockTheme={cx('imageModalBlock')}
                modalContentTheme={cx('modalContentTheme')}
                automationId={`${this.props.dataAutomationId}-ModelBox`}
            >
                <div className={cx('holder')}>
                    <button
                        className={cx('closeButton', { nativeClose: this.props.isNative })}
                        onClick={this.closeModal}
                        data-automation-id="modal-button"
                    >
                        <Icon
                            type="button"
                            iconType="svg"
                            width="24px"
                            height="24px"
                            viewBox="0 0 25 25"
                        >
                            <IconClose />
                        </Icon>
                    </button>
                    <StaticContainer>
                        <div
                            id="s7viewer"
                            className={cx('s7viewer')}
                            data-automation-id="ImageZoomViewer"
                            aria-label="productImageZoom"
                        />
                    </StaticContainer>
                </div>
                <Loading />
            </ModalBox>
        );
    }
}
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(LoadingAction, dispatch),
});

export default connect(null, mapDispatchToProps)(ImageZoom);
